
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campaign-intelligence/funnels",
      function () {
        return require("private-next-pages/campaign-intelligence/funnels.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campaign-intelligence/funnels"])
      });
    }
  